import { makeRequest, CommonRequestOptions } from '../makeRequest';

type SurveyJsConnectionResponse = {
   licenseKey: string;
};

export async function getSurveyJsConnection({
   ...common
}: CommonRequestOptions = {}): Promise<SurveyJsConnectionResponse> {
   return makeRequest('get', `/quizzes/surveyjs/surveyCreator`, {
      ...common,
   });
}
